export default __webpack_public_path__ + "static/media/instagram-blue.6435ebb8.svg";